import { callRpc, createRpcError } from './base';
import { ensureArray, ensureObject } from './util';

export interface ProgramPrintJobMeta {
  filters: Record<string, unknown> | null;
  created_at: string;
  selected_count: number;
}

export const createProgramPrintJob = async (
  filters: Record<string, unknown>,
  selectedIds: string[] | null
): Promise<string> => {
  return await callRpc('create_print_job', {
    params: {
      p_filters: filters,
      p_selected_ids: selectedIds && selectedIds.length > 0 ? selectedIds : null
    },
    transform: (data) => {
      if (typeof data !== 'string') {
        throw createRpcError(
          'INVALID_PRINT_JOB_RESPONSE',
          'Print job RPC did not return a job ID',
          { data, filters, selectedIds }
        );
      }
      return data;
    }
  });
};

export const getProgramPrintJob = async (jobId: string): Promise<ProgramPrintJobMeta> => {
  return await callRpc('get_print_job', {
    params: { p_job_id: jobId },
    transform: (data) =>
      ensureObject<ProgramPrintJobMeta>(
        data,
        'INVALID_PRINT_JOB_META',
        'Print job metadata RPC returned invalid data',
        { jobId }
      )
  });
};

export const getProgramPrintResults = async (
  jobId: string
): Promise<Record<string, unknown>[]> => {
  return await callRpc('get_print_results', {
    params: { p_job_id: jobId },
    transform: (data) =>
      ensureArray<Record<string, unknown>>(
        data,
        'INVALID_PRINT_RESULTS',
        'Print results RPC returned invalid data',
        { jobId }
      )
  });
};
